import * as types from '../constants';

export const initRoomListState = () => ({
  type: types.INIT_ROOM_LIST_STATE,
});

export const setViewType = viewType => ({
  type: types.SET_VIEW_TYPE,
  payload: viewType
});

export const setRoomList = roomList => ({
  type: types.SET_ROOM_LIST,
  payload: roomList
});

export const setCurrentPageNumber = currentPageNumber => ({
  type: types.SET_ROOM_LIST_CURRENT_PAGE_NUMBER,
  payload: currentPageNumber
});

export const setPaginationItem = paginationItem => ({
  type: types.SET_ROOM_PAGINATION_ITEM,
  payload: paginationItem
});

export const setFilterItem = filterItem => ({
  type: types.SET_ROOM_FILTER_ITEM,
  payload: filterItem
});